import axios from 'axios'
import { BOT_BASE_URL } from './consts'

export const BotVkClient = axios.create({
  baseURL: BOT_BASE_URL,
  withCredentials: true,
  headers: {
    accept: 'application/json',
    'Content-Type': 'application/json',
  },
})
